import logoLivo from './livologo.svg';
import livoWhiteLogo from './livoWhiteLogo.png';
import homeTherapyLogo from './homeTherapyLogo.png'
import loginImage from './login Image.png';
import loader from './loader.gif';
import exportImage from './exportImage.png';
import filterImage from './filterImage.png';
import totalVacant from './totalVacant.png';
import totalUnit from './totalUnit.png';
import totalProperty from './totalProperty.png';
import editIcon from './editIcon.png';
import cancelButton from './cancelButton.png';
import simpleCardIcon from './simpleCardIcon.png';
import totalUser from './totalUser.png';
import totalOpen from './totalOpen.png';
import totalCompleted from './totalCompleted.png';
import totalInProgress from './totalInProgress.png';
import listingPageIcon from './listingPageIcon.svg';
import NoDataFound from './NoDataFound.svg';
import checkIn from './checkIn.png';
import guardIcon from './guardIcon.png';
import activeCheckIn from './activeCheckIn.png';
import delivery from './delivery.svg';
import total from './total.svg';
import unique from './unique.svg';
import daily from './daily.svg';
import duration from './duration.svg';
import month from './month.svg';
import repeatVisitor from './repeatVisitors.svg';
import signOut from './signOut.svg';

export {
  logoLivo,
  loginImage,
  livoWhiteLogo,
  homeTherapyLogo,
  loader,
  exportImage,
  filterImage,
  totalVacant,
  totalUnit,
  totalProperty,
  editIcon,
  cancelButton,
  simpleCardIcon,
  totalUser,
  totalOpen,
  totalInProgress,
  totalCompleted,
  listingPageIcon,
  NoDataFound,
  checkIn,
  delivery,
  unique,
  total,
  daily,
  duration,
  month,
  repeatVisitor,
  signOut,
  activeCheckIn,
  guardIcon,
};
